module.exports = __webpack_public_path__ + "img/legs-off-bed.476f660b.png";